import api from "./api"

export const getEmailSettings = async (params = {}) => {
  try {
    const response = await api.get("/email-settings", { params })
    return {
      success: true,
      data: response.data,
    }
  } catch (error) {
    console.error("Error fetching email settings:", error)
    return {
      success: false,
      error: error.response?.data?.message || "Failed to load email settings",
    }
  }
}

export const updateEmailSettings = async (settings, params = {}) => {
  try {
    const response = await api.put("/email-settings", settings, { params })
    return {
      success: true,
      data: response.data,
    }
  } catch (error) {
    console.error("Error updating email settings:", error)
    return {
      success: false,
      error: error.response?.data?.message || "Failed to update email settings",
    }
  }
}

export const sendTestEmail = async (email, params = {}) => {
  try {
    const response = await api.post("/email-settings/test", { email }, { params })
    return {
      success: true,
      data: response.data,
    }
  } catch (error) {
    console.error("Error sending test email:", error)
    return {
      success: false,
      error: error.response?.data?.message || "Failed to send test email",
    }
  }
}

export const getEmailTemplates = async (params = {}) => {
  try {
    const response = await api.get("/email-settings/templates", { params })
    return {
      success: true,
      data: response.data,
    }
  } catch (error) {
    console.error("Error fetching email templates:", error)
    return {
      success: false,
      error: error.response?.data?.message || "Failed to load email templates",
    }
  }
}

export const resetEmailTemplate = async (templateName, params = {}) => {
  try {
    const response = await api.post(`/email-settings/templates/${templateName}/reset`, {}, { params })
    return {
      success: true,
      data: response.data,
    }
  } catch (error) {
    console.error("Error resetting email template:", error)
    return {
      success: false,
      error: error.response?.data?.message || "Failed to reset email template",
    }
  }
}

